import { render, staticRenderFns } from "./delay.vue?vue&type=template&id=b57ff3f2&scoped=true&"
import script from "./delay.vue?vue&type=script&lang=js&"
export * from "./delay.vue?vue&type=script&lang=js&"
import style0 from "./delay.vue?vue&type=style&index=0&id=b57ff3f2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b57ff3f2",
  null
  
)

export default component.exports